/** 无 Zip、以静态图 SKU 为主的 Spine 模版类型；新建静态模版默认取列表第一项 */
export const STATIC_SPINE_TEMPLATE_TYPES = ["bgStatic", "fgStatic"] as const;
export type StaticSpineTemplateType = (typeof STATIC_SPINE_TEMPLATE_TYPES)[number];

export function isStaticSpineTemplateType(
  type: string | undefined | null,
): type is StaticSpineTemplateType {
  return (
    type != null &&
    (STATIC_SPINE_TEMPLATE_TYPES as readonly string[]).includes(type)
  );
}

export const TEMPLATE_ORDER: Record<string, number> = {
  bgStatic: -500,
  bg: 0,
  bgEffect: 1000,
  character: 2000,
  fgStatic: 2500,
  fg: 3000,
  fgEffect: 4000,
};

export function getTemplateOrder(type?: string, isMain?: boolean) {
  if (type && TEMPLATE_ORDER[type] !== undefined) {
    return TEMPLATE_ORDER[type];
  }
  return isMain ? 2000 : 0;
}

export interface SpineTemplate {
  id: string;
  name?: string;
  intro?: string;
  state?: number;
  author?: string; //这个是发布者（假用户）Id
  onlinePublisher?: string; //这个是发布者（假用户）昵称
  painter?: string; //这个是创建者Id (publisherId)
  publisher?: string; //这个是创建者昵称 (publisherName)
  character?: number;
  cover?: string;
  preview?: string;
  videoCover?: string;
  videoPreview?: string;
  /** Cover Avatar 缩略 VAP 视频（300 mp4） */
  videoCoverPreview?: string;
  /** Preview Avatar 缩略 VAP 视频（300 mp4） */
  videoPreviewPreview?: string;
  createTime?: number;
  updateTime?: number;
  publishTime?: number;
  /** 预约上线时间（毫秒），state=100 时有效 */
  scheduledOnlineTime?: number;
  initDataId?: string;
  /** Preview 对应的 avatar id（仅存模板数据，不进 draft/frames） */
  previewId?: string;
  spineVersion?: number;
  spineFingerprint?: string;
  spineZipUrl?: string;
  spineCompressedZipUrl?: string;
  animations?: string;
  selections?: string;
  selectionIds?: string;
  tonings?: string;
  requireCategories?: string;
  type?: string; // bg/fg/bgEffect/fgEffect/character/bgStatic/fgStatic（后两者无 Zip，SKU 为静态图）
  relatedTemplateIds?: string[]; // 关联的模板 ID 数组
  /** 0 = 1:1，1 = 9:16 */
  fullscreenType?: number;
  /** 父模版 ID；有值即为子模版 */
  parentId?: string;
  /** 是否子模版（与 parentId 同步） */
  isChildTemplate?: boolean;
}

/** 判断是否为子模版 */
export function isChildSpineTemplate(
  template: Pick<SpineTemplate, "parentId" | "isChildTemplate"> | null | undefined,
): boolean {
  if (!template) return false;
  return Boolean(template.parentId) || template.isChildTemplate === true;
}